import Dashboard from '@mui/icons-material/Dashboard'
import Notifications from '@mui/icons-material/Notifications'
import Person from '@mui/icons-material/Person'
import Search from '@mui/icons-material/Search'
import {
  Box,
  Button,
  ClickAwayListener,
  Divider,
  Grow,
  Hidden,
  MenuItem,
  MenuList,
  Paper,
  Popper,
} from '@mui/material'
import CustomInput from 'materialUI/components/CustomInput/CustomInput.js'
import PropTypes from 'prop-types'
import React from 'react'
import styles from './adminNavbarLinksStyle.js'

export default function HeaderLinks(props) {
  const [openNotification, setOpenNotification] = React.useState(null)
  const handleClickNotification = (event) => {
    if (openNotification && openNotification.contains(event.target)) {
      setOpenNotification(null)
    } else {
      setOpenNotification(event.currentTarget)
    }
  }
  const handleCloseNotification = () => {
    setOpenNotification(null)
  }
  const [openProfile, setOpenProfile] = React.useState(null)
  const handleClickProfile = (event) => {
    if (openProfile && openProfile.contains(event.target)) {
      setOpenProfile(null)
    } else {
      setOpenProfile(event.currentTarget)
    }
  }
  const handleCloseProfile = () => {
    setOpenProfile(null)
    // props.history.push('/admin/userProfile');
  }
  const { rtlActive } = props

  const dropdownItem = [
    styles.dropdownItem,
    styles.primaryHover,
    rtlActive && styles.dropdownItemRTL,
  ]

  return (
    <Box component={'div'} sx={[rtlActive && styles.wrapperRTL]}>
      <CustomInput
        rtlActive={rtlActive}
        sx={{ ...styles.top, ...styles.search }}
        inputProps={{
          placeholder: rtlActive ? 'بحث' : 'Search',
          inputProps: {
            'aria-label': rtlActive ? 'بحث' : 'Search',
            className: styles.searchInput,
          },
        }}
      />
      <Button
        color="white"
        aria-label="edit"
        justicon={1}
        round={1}
        sx={[styles.top, styles.searchButton, rtlActive && styles.searchRTL]}
      >
        <Search sx={[styles.headerLinksSvg, styles.searchIcon]} />
      </Button>
      <Button
        transparent={1}
        simple={1}
        aria-label="Dashboard"
        justicon={1}
        sx={rtlActive ? styles.buttonLinkRTL : styles.buttonLink}
      >
        <Dashboard
          sx={[
            styles.headerLinksSvg,
            rtlActive && styles.links,
            rtlActive && styles.linksRTL,
            !rtlActive && styles.links,
          ]}
        />
        <Hidden mdUp implementation="css">
          <Box component={'span'} sx={styles.linkText}>
            {rtlActive ? 'لوحة القيادة' : 'Dashboard'}
          </Box>
        </Hidden>
      </Button>
      <Box component={'div'} sx={[styles.managerClasses]}>
        <Button
          transparent={1}
          justicon={1}
          aria-label="Notifications"
          aria-owns={openNotification ? 'notification-menu-list' : null}
          aria-haspopup="true"
          onClick={handleClickNotification}
          sx={[
            rtlActive && styles.buttonLinkRTL,
            !rtlActive && styles.buttonLink,
          ]}
        >
          <Notifications
            sx={[
              styles.headerLinksSvg,
              rtlActive && styles.links,
              rtlActive && styles.linksRTL,
              !rtlActive && styles.links,
            ]}
          />
          <Box component={'div'} sx={styles.notifications}>
            5
          </Box>
          <Hidden mdUp implementation="css">
            <Box
              component={'span'}
              onClick={handleClickNotification}
              sx={styles.linkText}
            >
              {rtlActive ? 'إعلام' : 'Notification'}
            </Box>
          </Hidden>
        </Button>
        <Popper
          open={Boolean(openNotification)}
          anchorEl={openNotification}
          transition
          disablePortal
          placement="bottom"
          sx={[
            styles.popperResponsive,
            styles.popperNav,
            !openNotification && styles.popperClose,
          ]}
        >
          {({ TransitionProps }) => (
            <Grow
              {...TransitionProps}
              id="notification-menu-list"
              style={{ transformOrigin: '0 0 0' }}
            >
              <Paper sx={styles.dropdown}>
                <ClickAwayListener onClickAway={handleCloseNotification}>
                  <MenuList role="menu">
                    <MenuItem
                      onClick={handleCloseNotification}
                      sx={dropdownItem}
                    >
                      {rtlActive
                        ? 'إجلاء أوزار الأسيوي حين بل, كما'
                        : 'Mike John responded to your email'}
                    </MenuItem>
                    <MenuItem
                      onClick={handleCloseNotification}
                      sx={dropdownItem}
                    >
                      {rtlActive
                        ? 'شعار إعلان الأرضية قد ذلك'
                        : 'You have 5 new tasks'}
                    </MenuItem>
                    <MenuItem
                      onClick={handleCloseNotification}
                      sx={dropdownItem}
                    >
                      {rtlActive
                        ? 'ثمّة الخاصّة و على. مع جيما'
                        : "You're now friend with Andrew"}
                    </MenuItem>
                    <MenuItem
                      onClick={handleCloseNotification}
                      sx={dropdownItem}
                    >
                      {rtlActive ? 'قد علاقة' : 'Another Notification'}
                    </MenuItem>
                    <MenuItem
                      onClick={handleCloseNotification}
                      sx={dropdownItem}
                    >
                      {rtlActive ? 'قد فاتّبع' : 'Another One'}
                    </MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </Box>
      <Box component={'div'} sx={[styles.managerClasses]}>
        <Button
          transparent={1}
          aria-label="Person"
          justicon={1}
          aria-owns={openProfile ? 'profile-menu-list' : null}
          aria-haspopup="true"
          onClick={handleClickProfile}
          sx={rtlActive ? styles.buttonLinkRTL : styles.buttonLink}
        >
          <Person
            sx={[
              styles.headerLinksSvg,
              rtlActive && styles.links,
              rtlActive && styles.linksRTL,
              !rtlActive && styles.links,
            ]}
          />
          <Hidden mdUp implementation="css">
            <Box
              component={'span'}
              onClick={handleClickProfile}
              sx={styles.linkText}
            >
              {rtlActive ? 'الملف الشخصي' : 'Profile'}
            </Box>
          </Hidden>
        </Button>
        <Popper
          open={Boolean(openProfile)}
          anchorEl={openProfile}
          transition
          disablePortal
          placement="bottom"
          sx={[
            styles.popperResponsive,
            styles.popperNav,
            !openProfile && styles.popperClose,
          ]}
        >
          {({ TransitionProps }) => (
            <Grow
              {...TransitionProps}
              id="profile-menu-list"
              style={{ transformOrigin: '0 0 0' }}
            >
              <Paper sx={styles.dropdown}>
                <ClickAwayListener onClickAway={handleCloseProfile}>
                  <MenuList role="menu">
                    <MenuItem onClick={handleCloseProfile} sx={dropdownItem}>
                      {rtlActive ? 'الملف الشخصي' : 'Profile'}
                    </MenuItem>
                    <MenuItem onClick={handleCloseProfile} sx={dropdownItem}>
                      {rtlActive ? 'الإعدادات' : 'Settings'}
                    </MenuItem>
                    <Divider light />
                    <MenuItem onClick={handleCloseProfile} sx={dropdownItem}>
                      {rtlActive ? 'الخروج' : 'Log out'}
                    </MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </Box>
    </Box>
  )
}

HeaderLinks.propTypes = {
  rtlActive: PropTypes.bool,
}
